<template>
  <div id="end-confirm">
    <ipub-model title=""
                width="400px"
                :visable="isVisable"
                :showHeader="false"
                style="text-align:center"
                @cancel="cancel"
                @confirm="confirm">
      <div class="content-center"
           style="">
        <ipub-icon type="iconDetails"
                   style="font-size:60px"
                   class="key-color"></ipub-icon>

        <div class="ipub-p2 content-center">
          <div v-if="inputData.__flag1">The Received Date to Revised Date is too close.</div>
          <div v-if="inputData.__flag2">The Revised Date to Accept Date is too close.</div>
          <div v-if="inputData.__flag3">The Accept Date to Published Date is too close.</div>
          Sure to publish the article?
        </div>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      // publisherInfo: 'getPublisherInfo',
    })
  },
  methods: {
    async confirm () {
      this.$emit('confirm', this.inputData.__status, this.inputData)
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
.content-center {
  margin: 0 auto 20px;
  text-align: center;
}
</style>
